export default "__VITE_ASSET__5kFvtv_o__"